import { ROLE_IDS } from '@/auth/utils'

const pageName = { singular: 'Divisi', plural: 'Divisi' }

export default [
  {
    path: '/divisions',
    name: 'divisions',
    component: () => import('@/views/pages/division/List.vue'),
    meta: {
      name: pageName,
      resource: 'Division',
      action: 'manage',
      allowedRoles: [ROLE_IDS.ADMIN],
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
]
